import { render, staticRenderFns } from "./TicketScan.vue?vue&type=template&id=35774e2b"
import script from "./TicketScan.vue?vue&type=script&lang=js"
export * from "./TicketScan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports